import React from "react";
import cx from "classnames";

type Props = {
  className?: string;
};

const IconFacebook = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="30"
    className={cx("shareLink shareLink--fb", className)}
  >
    <path
      fill="#B1B5B6"
      d="M9.583 29.27V16.302h4.353l.651-5.054H9.583V8.022c0-1.464.406-2.46 2.504-2.46l2.677-.002V1.04c-.463-.062-2.052-.2-3.9-.2-3.859 0-6.5 2.356-6.5 6.681v3.727H0v5.054h4.364V29.27h5.219z"
    />
  </svg>
);

export default IconFacebook;
